import Vue from 'vue'

class ProdutoService {
  async busca(
    uf,
    operadora,
    tipo_plano,
    contratacao,
    cidade,
    compulsorio,
    coparticipacao,
    acomodacao,
    regras_aceitacao,
    credenciado,
    entidade,
    profissao,
    faixas,
    grupos_faixas,
    mei
  ) {
    try {
      let t = contratacao == 'a' && tipo_plano == 's' ? 'a' : tipo_plano,
          c = contratacao == 'a' ? 'pf' : contratacao,
          a = contratacao == 'a' ? '1' : '0',
          r = regras_aceitacao == 'n' ? '0' : '2'
      let params = [
        { key: 'compulsorio', value: compulsorio },
        { key: 'coparticipacao', value: coparticipacao },
        { key: 'acomodacao', value: acomodacao },
        { key: 'filtrar_faixas', value: r },
        { key: 'credenciado', value: credenciado },
        { key: 'entidade', value: entidade },
        { key: 'profissao', value: profissao },
        { key: 'adesao', value: a },
        { key: 'mei', value: mei }
      ].map(p => p.key+'='+(p.value||''))
       .join('&');
      const response = await Vue.prototype.$http.post(
        `produtos/${uf}/${operadora}/${t}/${c}/${cidade||''}?${params}`,
        {
          faixas: Object.fromEntries(
            Object.entries(
              Object.assign(
                {},
                faixas.map(
                  f => Number(f.value)
                )
              )
            ).map(([ key, val ]) => [ (parseInt(key)+1), val])
          ),
          faixas_global: Object.fromEntries(
            Object.entries(
              Object.assign(
                {},
                grupos_faixas.map(
                  f => Number(f.value)
                )
              )
            ).map(([ key, val ]) => [ (parseInt(key)+1), val])
          )
        }
      )
      return await response.data;
    } catch (error) {
      throw error
    }
  }
}

export default new ProdutoService();
